import React from 'react'

import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default class SaisieLibreBool extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} title={this.props.title}>
        <Grid container style={{margin: 0, padding: 0}} spacing={0} justify={'center'} alignItems={'center'}>
          <Grid item xs={11} style={{margin: 0, padding: 0}}>
            <Traduction style={this.props.style} inline={this.props.inline}
              onChange={this.props.onChangeSaisieLibreBool}
              name={'text'}
              disabled={this.props.disabled || false}
              data={this.props.data !== undefined && this.props.data.text !== undefined ? this.props.data.text : []}
              type={Constants.typeSaisie.SaisieLibre}
            />
          </Grid>
          <Grid item xs={1} style={{margin: 0, padding: 0}}>
              <button type="button" onClick={this.props.onClickBoolSaisieLibreBool}
                      disabled={this.props.disabled || false}
                      className={'fa fa-' + (this.props.data !== undefined && (this.props.data.valeur_bool === true || this.props.data.valeur_bool === 1 || parseInt(this.props.data.valeur_bool) === 1) ? 'check-circle-o text-success' : 'times-circle-o text-danger')}
              />
          </Grid>
        </Grid>
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/SaisieLibre/SaisieLibreBool.js